import styled, { css } from 'styled-components';
import { headLine3, headLine4, linkText, para1, para2, readmoreText } from '../theme/GlobalStyle';

export const MainContainer = styled.div`
  .policy-content {
    padding: 10px 0 30px;
    margin: 0 auto;
    color: ${(props) => props.theme.color.textLight};
    ${para1}
  }
  padding: 40px 0;

  .news-content {
    padding: 10px 0 30px;
    margin: 0 auto;
    color: ${(props) => props.theme.color.textLight};
    ${para1}
  }
  @media (max-width: 768px) {
    .news-content {
      padding: 0 0 20px;
    }
  }
`;

export const PostContainer = styled.ul`
  padding: 20px 0;
  display: flex;
  flex-wrap: wrap;

  &.mobile-container { display: none }
  li {
    margin: 30px 2% 0 0;
    flex-basis: 32%;
    h3 a {
      ${headLine4}
      color: ${(props) => props.theme.color.textLight};
    }
  }
  li:nth-child(3n + 2) {
    margin-right: ${(props) => (props.secondary ? null : '0')};
  }
  li:nth-child(3n + 3) {
    margin-right: ${(props) => (props.secondary ? 0 : null)};
  }

  li:first-child {
    flex-basis: ${(props) => (props.secondary ? null : '60%')};
    h3 a {
      ${(props) => (props.secondary ? headLine4 : headLine3)}
    }
  }

  @media (max-width: 995px) {
    justify-content: space-between;
    li {
      flex-basis: 48%;
    }
    li:first-child {
      flex-basis: 100%;
    }
    li {
      margin: 30px 0 0 0;
    }
  }
  @media (max-width: 768px) {
    &.mobile-container { display: block; }
    &.desktop-container { display: none; }
    li.sign-up-banner { margin: 20px 0 32px 0; }
  }
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const HyperlinkCategories = styled.ul`
  margin: 3px 0;
  display: flex;
  flex-wrap: wrap;
  transform: translateX(-10px);
  .link-item {
    padding: 0 10px;
    margin: 2px 0;
    position: relative;
    &:after {
      content: '';
      width: 1px;
      height: 60%;
      background-color: ${(props) => props.theme.color.textLight};
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }
    &:last-child:after {
      display: none;
    }
  }
  a {
    ${linkText}
    color: ${(props) => props.theme.color.textLight};
    transition: text-decoration ease-in-out 0.2s, color ease-in-out 0.2s;
  }
  a.active {
    color: ${(props) => props.theme.color.primary};
    text-decoration: underline;
  }
  @media (min-width: 1024px) {
    a:hover {
      color: ${(props) => props.theme.color.primary};
      text-decoration: underline;
    }
  }
`;

export const CardContainer = styled.ul`
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  .news, .com-policy-list-page {
    margin: 30px 2% 0 0;
    flex-basis: 32%;
  }
  li:nth-child(3n + 3) {
    margin-right: 0;
  }

  @media (max-width: 995px) {
    padding: 0;
    justify-content: space-between;
    .news, .com-policy-list-page {
      margin: 30px 0 0;
      flex-basis: 48%;
    }
  }
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const Pagination = styled.ul`
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  li a {
    width: 35px;
    height: 35px;
    margin: 10px;
    border: 1px solid ${(props) => props.theme.color.lightGrey};
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.color.primary};
    ${para2}
    transition: text-decoration ease-in-out 0.2s, color ease-in-out 0.2s;
    svg {
      color: ${(props) => props.theme.color.paginationStroke};
    }
    &.active {
      color: ${(props) => props.theme.color.white};
      background-color: ${(props) => props.theme.color.primary};
    }
    @media (min-width: 1024px) {
      &:hover {
        color: ${(props) => props.theme.color.white};
        background-color: ${(props) => props.theme.color.primary};
      }
    }
    &.disabled {
      svg {
        color: ${(props) => props.theme.color.paginationStroke};
        stroke: ${(props) => props.theme.color.paginationStroke};
        fill: ${(props) => props.theme.color.paginationStroke};
      }
      background-color: ${(props) => props.theme.color.lightGrey};
    }
  }
`;

export const Title = styled.h3`
  padding: 5px 0 10px;
  ${headLine3}
`;

export const ShowMore = styled.button`
  margin-top: 8px;
  border: none;
  display: none;
  background-color: ${(props) => props.theme.color.white};
  color: ${(props) => props.theme.color.primary};
  cursor: pointer;
  ${readmoreText}
  text-decoration: underline;
  text-transform: capitalize;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const TagButtonGroup = styled.ul`
  display: flex;
  flex-wrap: wrap; 
  align-items: center;

  @media (max-width: 768px) {
    max-height: ${(props) => (props.isShowing ? 'max-content' : '250px')};
    overflow: hidden;
  }
  
  & li {
    cursor: pointer;
    a {
      padding: 6px 8px;
      border: 1px solid ${(props) => props.theme.color.primary};
      border-radius: 6px;
      margin: 5px 0;
      display: inline-block;
      outline: none;
      background-color: transparent;
      color: ${(props) => props.theme.color.bgPrimary};
      ${readmoreText}
      transition: background-color ease-in-out 0.2s, color ease-in-out 0.2s;
      ${({ secondary }) =>
        secondary &&
        css`
          padding: 8px 10px;
          border: 1px solid ${(props) => props.theme.color.bgPrimary};
          `}
      &.active {
        background-color: ${(props) => props.theme.color.bgPrimary};
        color: ${(props) => props.theme.color.white};
        pointer-events: none;
      }
      @media (min-width: 1024px) {
        &:hover {
          background-color: ${(props) => props.theme.color.bgPrimary};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
    margin-right: 10px;
    }
  li.tagBtn.active button {
    background-color: ${(props) => props.theme.color.primary};
    color: ${(props) => props.theme.color.white};
  }
  @media (max-width: 824px) {
    li {
      button {
        margin: 5px;
      }
    }
  }
`;
